// The Loss runs panel's place in the URL (BRK-S361): `?lossRuns=1` opens it
// over the submission's page or the application's step, by the rules every
// URL overlay shares (`useUrlOverlay`, BRK-S357): opening pushes an entry, so
// the browser's Back closes it, and a link opens it directly.

export const LOSS_RUNS_PARAM = "lossRuns";

/** The mark on an entry the panel pushed. */
export const LOSS_RUNS_MARK = "lossRunsPanel";

/** Whether the URL opens the panel. */
export function readLossRunsPanel(params: URLSearchParams): boolean {
  return params.get(LOSS_RUNS_PARAM) === "1";
}
